import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/functions';

import env from './env';

const config =  {
  apiKey: env('FIREBASE_API_KEY'),
  authDomain: env('FIREBASE_AUTH_DOMAIN'),
  databaseURL: env('FIREBASE_DATABASE_URL'),
  projectId: env('FIREBASE_PROJECT_ID'),
  storageBucket: env('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('FIREBASE_MESSAGING_SENDER_ID'),
};

// ローカルのFirebase Emulatorだけに接続する。demo-で始まるprojectIdは実際のFirebaseに繋がらない
const isLocalEmulator = import.meta.env.VITE_USE_LOCAL_EMULATOR === 'true';
const emulatorConfig = {
  apiKey: 'demo-api-key',
  projectId: 'demo-yui',
  storageBucket: 'demo-yui.appspot.com',
};

firebase.initializeApp(isLocalEmulator ? emulatorConfig : config);

let functionsInstance;
const isEmulator = isLocalEmulator || env('CLOUD_FUNCTIONS_EMULATOR') === 'true';

if(isLocalEmulator) {
  firebase.auth().useEmulator('http://127.0.0.1:9099');
  firebase.firestore().useEmulator('127.0.0.1', 8080);
  firebase.storage().useEmulator('127.0.0.1', 9199);
  functionsInstance = firebase.app().functions('asia-northeast1');
  functionsInstance.useEmulator('127.0.0.1', 5001);
} else if(isEmulator) {
  functionsInstance = firebase.app().functions('asia-northeast1');
  functionsInstance.useFunctionsEmulator('http://localhost:5000');
} else {
  functionsInstance = firebase.app().functions(env('FUNCTIONS_DOMAIN') || 'asia-northeast1');
}

export const functions = {
  httpsCallable: (name, options) => functionsInstance.httpsCallable(isEmulator ? name : name.toLowerCase(), options)
};

export default firebase;
